// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__9OgGY","employee-header-item":"Header_employee-header-item__aGi6v"};